<template>
  <div class="container">
    <home-nav-bar class="top-nav-bar" :border="false" :title="baseInfo.landName">
      <template #left>
        <router-link :to="{name: 'MyPlot'}">
          <van-icon name="arrow-left" />
        </router-link>
      </template>
      <template #right>
        <van-popover
          v-model="showNavRightPopover"
          close-on-click-action
          class="nav-right"
          trigger="click"
          placement="bottom-end"
          :offset="[10,8]"
          :actions="[
            {text: '历史种养'},
            {text: '编辑地块'},
            {text: '删除地块', className: 'danger'},
          ]"
          @select="navRightSelect"
        >
          <template #reference>
            <van-icon class="icon" name="ellipsis" />
          </template>
        </van-popover>
      </template>
    </home-nav-bar>
    <div class="map-container">
      <wh-map-draw v-if="baseInfo.latLng" class="land-map" :editable="false" :geometry-j-s-o-n="baseInfo.latLng" />
      <div class="bottom-info">
        <div class="area">
          占地面积：{{ baseInfo.landArea }} {{ baseInfo.landAreaUnit }}
        </div>
        <van-tag type="primary" class="land-type">
          {{ baseInfo.landType }}
        </van-tag>
      </div>
    </div>
    <van-tabs
      v-model="activeName"
      class="second-nav"
      color="#41c19e"
      title-active-color="#41c19e"
      line-height="1"
      @click="secondNavClick"
    >
      <van-tab
        v-for="(item,key) in plotDetailNavOption"
        :key="key"
        :title="item.title"
        :name="item.name"
      />
    </van-tabs>
    <router-view />
    <plot-popup
      :visible.sync="popup.plot.visible"
      :form-type="popup.plot.formType"
      :init-form-data="popup.plot.initFormData"
      @submitFormSuccess="plotPopupSubmitRes"
    />
  </div>
</template>

<script>
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import api from '@/api'
import plotDetailChildren from '@/router/modules/productManage/PlotDetail/plotDetailChildren'
import WhMapDraw from '@/components/public/WhMapDraw/WhMapDraw'
import PlotPopup from '@/views/productManage/components/PlotPopup'
export default {
  name: 'PlotDetail',
  components: { PlotPopup, WhMapDraw, HomeNavBar },
  props: {
    // 通过绑定 route.query 传递
    landId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      popup: {
        plot: {
          visible: false,
          formType: 'edit',
          initFormData: {}
        }
      },
      showNavRightPopover: false,
      activeName: this.$route.name,
      baseInfo: {
        landName: ''
      },
      plotDetailNavOption: plotDetailChildren.filter(item => item.meta.show !== false).map(item => {
        return {
          ...item.meta,
          name: item.name,
          path: item.path
        }
      })
    }
  },
  watch: {
    landId: {
      handler(newVal) {
        this.setFarmlandData(newVal)
      },
      immediate: true
    }
  },
  methods: {
    navRightSelect(val) {
      switch (val.text) {
        case '编辑地块':
          this.popup.plot.initFormData = this.baseInfo
          this.popup.plot.visible = true
          // console.log('this.baseInfo = ', this.baseInfo)
          break
        case '删除地块':
          this.deleteLand(this.baseInfo.id)
          break
        case '历史种养':
          this.$router.push({
            name: 'CropBreedHistory',
            query: {
              landId: this.landId,
              companyId: this.$store.getters.companyInfo.id
            }
          })
          break
      }
      // console.log(val)
    },
    deleteLand(landId) {
      this.$dialog.confirm({
        title: `是否删除地块（${this.baseInfo.landName}）？`
      })
        .then(() => {
          api.deleteFarmland({ ids: [landId] }).then(res => {
            this.$toast.success(res.msg)
            this.$router.push({
              name: 'MyPlot'
            })
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    secondNavClick(name) {
      // console.log(name)
      if (this.$route.name !== name) {
        this.$router.push({
          name: name,
          query: {
            ...this.$route.query
          }
        })
      }
    },
    setFarmlandData(id) {
      api.getFarmland({ id }).then(res => {
        this.baseInfo = res.data
      })
    },
    plotPopupSubmitRes(form) {
      if (form) {
        Object.assign(this.baseInfo, form)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/deep/ .nav-right {
  .icon {
    margin-right: 10px;
  }
}
.map-container {
  height: 220px;
  width: 100%;
  position: relative;
  background: url('~@/assets/images/productManage/land-map-bg.png') center center no-repeat;
  background-size: cover;
  flex-shrink: 0;
  .land-map {
    height: 100%;
    width: 100%;
  }
  .bottom-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    background: rgba(0, 0, 0, 0.5);
    color: #e8e8e8;
  }
  .land-type {
    height: 20px;
  }
}
.second-nav {
  box-shadow: 0 2px 4px 0 rgba(126,136,130,.2);
}
</style>
